module.exports = __webpack_public_path__ + "img/board.fe6ff92f.svg";